/**
 * Generated by orval v8.2.0 🍺
 * Do not edit manually.
 * Fragment Payments API
 * REST API for Fragment payment operations
 * OpenAPI spec version: 1.0.0
 */

/**
 * The type of the line item
 */
export type InvoiceLineItemType = (typeof InvoiceLineItemType)[keyof typeof InvoiceLineItemType];

export const InvoiceLineItemType = {
  payin: 'payin',
  payout: 'payout',
} as const;
